import { render, staticRenderFns } from "./JSelectJiaoshi.vue?vue&type=template&id=4e3591b4&scoped=true"
import script from "./JSelectJiaoshi.vue?vue&type=script&lang=js"
export * from "./JSelectJiaoshi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3591b4",
  null
  
)

export default component.exports